import { Link } from "react-router-dom";

import { useTranslation } from "react-i18next";
import "../../styles/all.css";
import "./navbar.css";
import logo from "../../img/logo.jpg";
import { useState } from "react";

function Navbar() {
    const [isactive,setactive]=useState(false);
      const { t, i18n } = useTranslation();
       const changeLanguage = (e) => {
        const lang=e.target.value
    i18n.changeLanguage(lang);
    localStorage.setItem("lang",lang)
  };
   
  return (
    <>
      <div className="container">
        <div className="logo">
          <img src={logo} alt="Company Logo" />
        </div>

                <div className={`links ${isactive ? "active" : ""}`}>
          <ul>
            <li>
              <Link to="/home">{t("onelink")}</Link>

            </li>
            <li>
              <Link to="/services">{t("twolink")}</Link>

            </li>
            <li>
                <Link to="/blog">{t("threelink")}</Link>

            </li>
            <li>
                <Link to="/about">{t("fourlink")}</Link>
            </li>
            <li>
                <Link to="/join">{t("fivelink")}</Link>
            </li>
            <li>
                        <button className="order-btn order">{t("order_button")}</button>

            </li>
            <li>
              <select name="language" onChange={changeLanguage} id="language-select">
                <option disabled>Choose Option</option>
                <option value="en">English</option>
                <option value="ar">Arabic</option>
              </select>
            </li>
          </ul>
        </div>

        <div className="icon">
          <button className="order-btn">{t("order_button")}</button>

          <div className="toggle" onClick={()=>setactive(!isactive)}>
<i className={isactive ? "fa-solid fa-x" : "fa-solid fa-bars"}></i>
          </div>
        </div>
      </div>
    </>
  );
}

export default Navbar;